var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultipleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 40,
    viewBox: "0 0 100 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0C2.62634 9.75434 10.2457 17.3737 20 20C10.2457 22.6263 2.62634 30.2457 0 40C0.000439756 27.677 0.0002379 14.9748 3.00165e-05 1.89332L0 0ZM20 0C22.6263 9.75434 30.2457 17.3737 40 20C30.2457 22.6263 22.6263 30.2457 20 40C20.0004 27.6713 20.0002 14.9629 20 1.875L20 0ZM60 20C50.2457 17.3737 42.6263 9.75434 40 0L40 1.875C40.0002 14.9629 40.0004 27.6713 40 40C42.6263 30.2457 50.2457 22.6263 60 20ZM60 0C62.6263 9.75434 70.2457 17.3737 80 20C70.2457 22.6263 62.6263 30.2457 60 40C60.0004 27.6713 60.0002 14.9629 60 1.875L60 0ZM100 20C90.2457 17.3737 82.6263 9.75434 80 0L80 2.08333C80.0002 15.0978 80.0004 27.7367 80 40C82.6263 30.2457 90.2457 22.6263 100 20Z",
    fill: "#070A26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleArrow);
export default __webpack_public_path__ + "static/media/multiple-arrow.c9642df295df084772f664a9256b8041.svg";
export { ForwardRef as ReactComponent };